import React from 'react';
import Navbar from '../components/Navbar';
import './Privacy.css'; // Reusing Privacy.css for consistent layout

function Refund() {
    return (
        <div className="page-container privacy-page">
            <Navbar />

            <section className="privacy-hero">
                <div className="container">
                    <div className="privacy-hero-content">
                        <span className="section-badge">Policy</span>
                        <h1 className="privacy-title">
                            Refund <span className="gradient-text">Policy</span>
                        </h1>
                        <p className="privacy-subtitle">
                            Last updated: March 19, 2026
                        </p>
                    </div>
                </div>
            </section>

            <section className="privacy-content">
                <div className="container">
                    <div className="privacy-wrapper">
                        <div className="privacy-section">
                            <h2>Returns and Refunds Policy</h2>
                            <p>
                                Thank you for choosing Talk to Krishna. We value your commitment to spiritual growth and strive to provide the best possible experience at <a href="https://india.talktokrishna.ai">india.talktokrishna.ai</a>.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Non-tangible irrevocable goods ("Digital products")</h2>
                            <p>
                                We do not issue refunds for non-tangible irrevocable goods ("digital products") once the order is confirmed and the product is sent.
                            </p>
                            <p>
                                Since our primary services involve AI-guided divine conversations and spiritual content access, these digital nature of our products means that once access is granted, it cannot be "returned."
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Support and Assistance</h2>
                            <p>
                                We recommend contacting us for assistance if you experience any issues receiving our services, accessing your chats, or if you encounter any technical difficulties.
                            </p>
                            <p>
                                Our team is dedicated to ensuring your spiritual journey remains uninterrupted and meaningful.
                            </p>
                        </div>

                        <div className="privacy-section">
                            <h2>Contact Us</h2>
                            <p>
                                If you have any questions about our Returns and Refunds Policy, please contact us:
                            </p>
                            <ul>
                                <li>
                                    <strong>Email:</strong> <a href="mailto:support@talktokrishna.ai">support@talktokrishna.ai</a>
                                </li>
                                <li>
                                    <strong>Website:</strong> <a href="/contact">Contact Form</a>
                                </li>
                            </ul>
                        </div>

                        <div className="privacy-footer-note">
                            <p>
                                <strong>Divine Commitment:</strong> By proceeding with your purchase, you acknowledge and agree to this policy. We thank you for being a part of the Talk to Krishna family.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Refund;
